import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import imgFallback from 'src/utils/image';

function Benefits(data) {
  const {
    benefits: { title, benefits, hasOwnBg },
  } = data;

  return (
    <div className={`${hasOwnBg ? 'bg-darker' : ''}`}>
      <Container>
        <Row className="py-6">
          <Col className="mb-lg-6 mb-xl-8 mb-3 text-center text-white" xs={12} lg={{ span: 8, offset: 2 }}>
            <h2 className="text-white">{title ?? '[title]'}</h2>
          </Col>
          {benefits?.length > 0 && (
            <Col xs={12}>
              <Container className="px-0">
                <Row noGutters>
                  {benefits.map((benefit) => (
                    <Col key={benefit._key} xs={6} lg={3} className="px-lg-3 mb-xl-6 my-3">
                      <Container fluid>
                        <Row className="align-items-center">
                          <Col xs={12} md={6} className="d-flex align-items-center mb-3">
                            <GatsbyImage
                              alt={benefit.image?.alt ?? ''}
                              objectFit="contain"
                              style={{ height: '120px' }}
                              image={benefit.image?.image?.asset?.gatsbyImageData ?? imgFallback}
                            />
                          </Col>
                          {benefit.title && (
                            <Col
                              xs={12}
                              md={6}
                              className="d-flex align-items-center align-items-lg-start justify-content-center justify-content-lg-start"
                            >
                              <h4 className="text-size-sm text-lg-left text-center text-white">{benefit.title}</h4>
                            </Col>
                          )}
                        </Row>
                      </Container>
                    </Col>
                  ))}
                </Row>
              </Container>
            </Col>
          )}
        </Row>
      </Container>
    </div>
  );
}

export default Benefits;
